import { get } from "../../../shared/data";
import { objectToParamString } from "../../../shared/helpers";

export const getShotTemplate = (wipKey) => {
    return get(`/photography/wips/${wipKey}/template`);
};

export const getShipmentProductContexts = (shipmentKey, productKey) => {
    const paramString = objectToParamString({ shipment: shipmentKey, product: productKey });

    return get(`/tasking/contexts?${paramString}`).then((results) => {
        return results.map((p) => {
            const fullUpc = p.productModifier ? `${p.upc}-${p.productModifier}` : p.upc;
            const label = p.packageLevelName ? `${fullUpc} (${p.packageLevelName})` : fullUpc;

            return {
                ...p,
                fullUpc,
                label,
            };
        });
    });
};

export const getOriginalProductShots = (shipmentKey, productKey) => {
    return get(`/photography/wips/shots/${shipmentKey}/${productKey}/original-shots`);
};
